import React from 'react';

import FooterThree from '../common/footer/FooterThree';
import HeaderOne from '../common/header/HeaderOne';
import SEO from '../common/SEO';
import AboutFive from '../component/about/AboutFive';
import AboutFour from '../component/about/AboutFour';
import CtaLayoutOne from '../component/cta/CtaLayoutOne';
import ProcessOne from '../component/process/ProcessOne';
import BcrumbBannerOne from '../elements/breadcrumb/BcrumbBannerOne';
import ColorSwitcher from '../elements/switcher/ColorSwitcher';

const AboutUs = () => {

    return (
        <>
        <SEO title="About us" />
        <ColorSwitcher />
            <main className="main-wrapper">
                <HeaderOne />
                <BcrumbBannerOne 
                title="One of the fastest growing agency"
                paragraph ="We design and develop web and mobile applications for our clients worldwide."
                styleClass="thumbnail-4"
                mainThumb="/images/banner/banner-thumb-3.png"
                />
                <AboutFour />
                <ProcessOne />
                <AboutFive />
                
                <CtaLayoutOne />
                <FooterThree parentClass="" />
            </main>
        </>
    )
}

export default AboutUs;